import {I18N} from '@gravity-ui/i18n';
import {Lang} from '@gravity-ui/uikit';

import {LANG} from '~ui/constants';

type KeysData = Parameters<InstanceType<typeof I18N>['registerKeyset']>[2];
export type KeysetDictionary = Record<'en' | 'ru', KeysData>;

type I18nFn<T extends KeysetDictionary> = (
    key: keyof T[keyof T],
    options?: object | Record<string, unknown>,
) => string;

export const i18nStrict = <K extends KeysetDictionary = KeysetDictionary>(keyset: K) => {
    const i18n = new I18N();
    const keysetName = Date.now().toString(36) + Math.floor(Math.random() * 1000).toString(36);

    i18n.registerKeyset(Lang.En, keysetName, keyset.en);
    i18n.registerKeyset(Lang.Ru, keysetName, keyset.ru);

    i18n.setLang(LANG);

    return i18n.keyset(keysetName) as I18nFn<K>;
};
